export { default, type ServiceCarAccreditationProps } from './ServiceCarAccreditation';
